import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateClaimCategory, type IUpdateClaimCategoryParams } from '@/services/admin';

export function useUpdateClaimCategory() {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (params: IUpdateClaimCategoryParams) => updateClaimCategory(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['adminClaims'] });
      void queryClient.invalidateQueries({ queryKey: ['dashboard'] });
    },
  });

  return {
    updateCategory: mutation.mutateAsync,
    isPending: mutation.isPending,
  };
}
